import { render, staticRenderFns } from "./ChecklistPage.vue?vue&type=template&id=200213f2"
import script from "./ChecklistPage.vue?vue&type=script&lang=js"
export * from "./ChecklistPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports